import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../testOverview.scss';
import CallDescription from './CallDescription';
import CallFrame from './CallFrame';

const ZoomTestCallContainer = ({ credentials }) => {
    return (
        <div className={styles.zoomCallContainer}>
            <CallDescription />
            <CallFrame credentials={credentials} />
        </div>
    );
};

ZoomTestCallContainer.propTypes = {
    credentials: PropTypes.object,
};

export default ZoomTestCallContainer;
